(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    if (!annBar) return;

    // Rotate block-based messages and allow manual navigation to reset the timer.
    const rotator = annBar.querySelector("[data-announcement-rotator]");
    if (rotator) {
      const ROTATION_MS = 3000;
      const items = Array.from(
        rotator.querySelectorAll("[data-announcement-item]")
      );
      const controls = annBar.querySelector("[data-announcement-controls]");

      // Clear any previous interval stored on the element (theme editor reload safety).
      const existingIntervalId = rotator.dataset.rotationIntervalId;
      if (existingIntervalId) {
        clearInterval(Number(existingIntervalId));
        rotator.dataset.rotationIntervalId = "";
      }

      let currentIndex = items.findIndex((item) => !item.hidden);
      if (currentIndex === -1) currentIndex = 0;

      const setVisibleIndex = (index) => {
        items.forEach((item, itemIndex) => {
          item.hidden = itemIndex !== index;
        });
      };

      const advance = (direction) => {
        if (items.length < 2) return;
        items[currentIndex].hidden = true;
        currentIndex = (currentIndex + direction + items.length) % items.length;
        items[currentIndex].hidden = false;
      };

      const startRotation = () => {
        if (items.length < 2) return;
        const intervalId = window.setInterval(() => {
          advance(1);
        }, ROTATION_MS);
        rotator.dataset.rotationIntervalId = String(intervalId);
      };

      const resetRotation = () => {
        const intervalId = rotator.dataset.rotationIntervalId;
        if (intervalId) {
          clearInterval(Number(intervalId));
          rotator.dataset.rotationIntervalId = "";
        }
        startRotation();
      };

      // Ensure a single visible item before starting the loop to avoid layout flicker.
      setVisibleIndex(currentIndex);

      // Announce updates to assistive tech without forcing focus changes.
      rotator.setAttribute("aria-live", "polite");

      // Wire up manual controls once; hide them if there is only one message.
      if (controls) {
        if (items.length < 2) {
          controls.hidden = true;
        } else if (!controls.dataset.controlsBound) {
          controls.dataset.controlsBound = "true";
          controls
            .querySelectorAll("[data-announcement-control]")
            .forEach((button) => {
              button.addEventListener("click", () => {
                const direction =
                  button.dataset.announcementControl === "prev" ? -1 : 1;
                advance(direction);
                resetRotation();
              });
            });
        }
      }

      startRotation();
    }

    let intersectionObserver;
    let resizeObserver;
    let lastRatio = 1;

    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);
      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };

    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });

      if (annBar) intersectionObserver.observe(annBar);
      if (annBar) resizeObserver.observe(annBar);
    };

    createObservers();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
